var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9L21 3H7C5.9 3 5 3.9 5 5V22H7V15H21L16 9ZM7 5H16.73L13.4 9L16.73 13H7V5Z",
    fill: "#544F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.fda3109822512432397e27ba80f441de.svg";
export { ForwardRef as ReactComponent };